import { inject, observer } from 'mobx-react'
import * as React from 'react'
import { ListGroup, ListGroupItem } from 'react-bootstrap'
import { Questionnaire } from '../../../Model/Questionnaire'
import LocalizationStore from '../../../Stores/LocalizationStore'

export interface IQuestionnaireExternalDataViewProps {
    questionnaire: Questionnaire
    className?: string
    localizationStore?: LocalizationStore
}

@inject('localizationStore')
@observer
export default class QuestionnaireExternalDataView extends React.Component<IQuestionnaireExternalDataViewProps> {
    render() {
        const { questionnaire, className, localizationStore } = this.props
        return (
            <div className={className}>
                <ListGroup>
                    <ListGroupItem className="border-radius-0">
                        <span>
                            {localizationStore!.t!('orderSource')}&nbsp;:&nbsp;
                            {questionnaire.orderSource}
                        </span>
                    </ListGroupItem>
                    <ListGroupItem className="border-radius-0">
                        <span>
                            {localizationStore!.t!('externalKey')}&nbsp;:&nbsp;
                            {questionnaire.externalKey}
                        </span>
                    </ListGroupItem>
                </ListGroup>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Views/PartialViews/Questionnaire/QuestionnaireExternalDataView.tsx